import { render, staticRenderFns } from "./ChangeOperationsByUsers.vue?vue&type=template&id=2b4ba9db&scoped=true"
import script from "./ChangeOperationsByUsers.vue?vue&type=script&lang=js"
export * from "./ChangeOperationsByUsers.vue?vue&type=script&lang=js"
import style0 from "./ChangeOperationsByUsers.vue?vue&type=style&index=0&id=2b4ba9db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ba9db",
  null
  
)

export default component.exports